import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import FacilitatorApp from './FacilitatorApp';
import ParticipantJoin from './components/ParticipantJoin';
import LoginPage from './LoginPage';
import ProtectedRoute from './ProtectedRoute';
import ImageCredits from './imageCredits';
import SplashPage from './splashPage';
import SignupPage from './signupPage';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsConditions';
import AdminDash from './AdminDash';
import { AuthProvider } from './AuthContext';
import AdminRoute from './AdminRoute';

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/app/participant" element={<ParticipantJoin />} />

          <Route
            path="app/*"
            element={
              <ProtectedRoute>
                <FacilitatorApp />
              </ProtectedRoute>
            }
          />

          <Route path="/credits/image" element={<ImageCredits />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/" element={<SplashPage />} />

        </Routes>
      </Router>
    </AuthProvider>
  );
}